module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("62SVK"))).then(() => module.bundle.root('aVi2q'));